/**
 * Path reservation + system-type hide helpers from `@lobu/core/reserved`.
 *
 * IMPORTANT: import the `./reserved` subpath, never the `@lobu/core` barrel.
 * The barrel re-exports logger/otel/sentry (Node-only, top-level `process.env`).
 * Rollup cannot tree-shake those through CJS `__exportStar`, so a barrel import
 * ships `process` into the SPA and crashes prod with
 * `Uncaught ReferenceError: process is not defined`.
 */
import { decodeEntityTypeParam } from "@/lib/url";
import {
	isSystemEntityType,
	OWNER_ROUTE_SEGMENTS,
	REMOVED_OWNER_SEGMENTS,
	RESERVED_PATHS,
	RESERVED_PATHS_SET,
} from "@lobu/core/reserved";

export { isSystemEntityType, RESERVED_PATHS, RESERVED_PATHS_SET };

/** Owner-level + removed legacy pages only (not global prefixes like auth/api). */
const RESERVED_OWNER_SEGMENTS_SET = new Set<string>([
	...OWNER_ROUTE_SEGMENTS,
	...REMOVED_OWNER_SEGMENTS,
]);

/**
 * True when a URL segment must not be treated as a user-defined entity type
 * (owner-level routes and removed legacy pages).
 */
export function isReservedOwnerSegment(segment: string): boolean {
	return RESERVED_OWNER_SEGMENTS_SET.has(decodeEntityTypeParam(segment));
}
